import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: inline-flex;
  gap: 16px;
  label {
    cursor: pointer;
  }
`;

export const StyledLabel = styled.label`
  width: 20px;
  height: 20px;
  background: ${() => Palette.PrimaryGray._000};
  border: 2px solid ${() => Palette.PrimaryGray._400};
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  transition: 0.1s ease-in-out;

  &:hover {
    border-color: ${() => Palette.Primary._500};
  }

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  ${({ isChecked }) =>
    isChecked &&
    css`
      background: ${() => Palette.Primary._500};
      border-color: ${() => Palette.Primary._500};
      border-radius: 2px;
      &:hover {
        background: ${() => Palette.Primary._600};
        border-color: ${() => Palette.Primary._600};
      }
    `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 0;
`;
